// angular
// 	.module("HeroPRO")
// 	.controller("DeleteUserController", deleteUserController);

import _ from 'lodash';

import './deleteUser.scss';

/* @ngInject */
export default function deleteUserController($uibModalInstance, selectedUser, AccountsFactory) {
    const vm = this;
    vm.selectedUser = selectedUser;
    vm.jobLocations = null;
    vm.usersByLocation = [];
    vm.blockDisableButtonClick = true;
    vm.selectedUserHasJobs = null;
    vm.contractorJobLocationsReturned = false;
    vm.contentShown = 'deleteInProgress';
    vm.successData = [];
    vm.disableDeleteButton = true;

    init();

    /*= =======================================
	=            Public Functions            =
	======================================== */
    vm.closeModal = function () {
        let result = false;

        if (vm.contentShown === 'deleteSuccess') {
            result = true;
        }

	 	$uibModalInstance.close(result);
	 };

	 vm.transferToUser = function (location, newUser) {
	 	const tempLocation = _.find(vm.usersByLocation, locationObject => location.ContractorId === locationObject.ContractorId);

	 	tempLocation.newContractorUser = newUser;
	 	setDeleteButtonStatus();
	 };

	 vm.reassignJobsAndDeleteUser = function () {
	 	const newSalesReps = [];

	 	_.each(vm.usersByLocation, (location) => {
	 		newSalesReps.push({
	 			ContractorLocationId: location.ContractorId,
	 			ContractorUserId: location.newContractorUser.ContractorUserId,
	 		});

	 		vm.successData.push([
	 			location.nickname,
	 			`${location.newContractorUser.FirstName} ${location.newContractorUser.LastName}`,
 			]);
	 	});

	 	AccountsFactory.reassignJobsAndDeleteUser({
	 		ContractorUserId: vm.selectedUser.ContractorUserId,
	 		NewSalesRepAndLocation: newSalesReps,
	 	}).then(() => {
	 		vm.contentShown = 'deleteSuccess';
	 	});
	 };
    /* -----  End of Public Functions  ------*/

    /*= =======================================
	=            Private Functions           =
	======================================== */
    function init() {
        AccountsFactory.getContractorJobLocations({
            ContractorUserId: vm.selectedUser.ContractorUserId,
        }).then((response) => {
            vm.contractorJobLocationsReturned = true;
            
            const responseData = response.data.Data;
            
            if (_locationsAreAvailable(responseData.Locations)) {
                vm.selectedUserHasJobs = true;
                vm.jobLocations = responseData.Locations;

                AccountsFactory.getContractorUsersByLocation({
                    ContractorLocationIds: _.pluck(vm.jobLocations, 'ContractorId'),
                }).then((response) => {
                    processUsersByLocation(response.data.Data);
                    setDeleteButtonStatus();
                });
            } else {
                vm.selectedUserHasJobs = false;
                setDeleteButtonStatus();
            }
        });
    }

    function processUsersByLocation(data) {
        const tempLocations = [];
        _.each(vm.jobLocations, (location) => {
            tempLocations[location.ContractorId] = {
                nickname: location.Nickname,
            };
        });

        vm.usersByLocation = _.each(data, (location) => {
            location.nickname = tempLocations[location.ContractorId].nickname;
            location.newContractorUser = null;

            // Remove the currentUser from the list of users from each location
            location.Users = _.filter(location.Users, user => user.ContractorUserId !== vm.selectedUser.ContractorUserId);
        });
    }

    function setDeleteButtonStatus() {
        vm.disableDeleteButton = _.some(vm.usersByLocation, location => location.newContractorUser === null) && vm.selectedUserHasJobs === true;
    }

    const _locationsAreAvailable = (locations) => !!locations && locations.length > 0; 
    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/accounts/user/deleteUser/deleteUserController.js